module.exports = __webpack_public_path__ + "img/dsci0074.e82c1749.jpg";